import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <nav className="hub-navbar navbar navbar-expand-lg">
      <div className="container-xl">

        {/* Brand */}
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/" onClick={() => setOpen(false)}>
          <div className="wz-logo">
            <span className="wz-word">Word</span><span className="wz-zingo">Zingo</span>
          </div>
          <div className="wz-tagline d-none d-md-flex">Play · Solve · Win</div>
        </Link>

        {/* Mobile toggle */}
        <button
          className="navbar-toggler border-0"
          style={{ color: '#fff', fontSize: '1.4rem' }}
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          <i className={`bi bi-${open ? 'x-lg' : 'list'}`}></i>
        </button>

        {/* Nav links */}
        <div className={`collapse navbar-collapse ${open ? 'show' : ''}`}>
          <ul className="navbar-nav ms-auto align-items-lg-center gap-1">
            {!isHome && (
              <li className="nav-item">
                <Link className="nav-link" to="/" onClick={() => setOpen(false)}>
                  <i className="bi bi-grid me-1"></i>All Games
                </Link>
              </li>
            )}
            <li className="nav-item">
              <Link className="nav-link" to="/wordle" onClick={() => setOpen(false)}>
                <i className="bi bi-grid-3x3 me-1"></i>Wordle
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/hangman" onClick={() => setOpen(false)}>
                <i className="bi bi-person me-1"></i>Hangman
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/word-scramble" onClick={() => setOpen(false)}>
                <i className="bi bi-shuffle me-1"></i>Scramble
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link wz-play-btn" to="/word-search" onClick={() => setOpen(false)}>
                <i className="bi bi-search me-1"></i>Word Search
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
